<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Họ tên" v-model="name" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Tên đăng nhập" v-model="username" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Email" v-model="email" clearable flat outlined dense hide-details />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="primary" height="40px" width="100%" outlined @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['user'])
  },
  props: {
    roles: Array
  },
  created() {
    if (this.$route.query) {
      this.setFiltersFromQuery(this.$route.query)
    }
  },
  data() {
    return {
      name: '',
      username: '',
      email: '',
      role: '',
      blocked: '',
      statusOptions: [
        {title: 'Đang hoạt động', value: 'false'},
        {title: 'Đã bị khóa', value: 'true'}
      ]
    }
  },
  methods: {
    onFilterChanged() {
      let query = {
        name_contains: this.name,
        username_contains: this.username,
        email_contains: this.username,
        role: this.role,
        blocked: this.blocked
      }
      this.$emit('onFilterChanged', query)
    },
    setFiltersFromQuery(query) {
      Object.keys(query).forEach(key => {
        this[key] = query[key]
      })
    }
  }
}
</script>
